import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../../../../shared/services/app-message/app-message.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-file-upload-dialog',
  templateUrl: './add-file.modal.component.html',
  styleUrls: ['./add-file.modal.component.scss'],
})
export class CoreFileUploadDialogComponent {
  displayUploadDialog = false;
  fileDescription = '';

  @Input() moduleName: string = 'organization';
  @Output() fileAdded = new EventEmitter<any>();

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('selectedFileDesc') fileDescSelector!: ElementRef;

  fileError: string | null = null;
  uploadedFile: any = null;
  uploadedPrevFiles: any[] = [];

  signedUser: any = null;

  // Preview
  filePreviewType: 'image' | 'pdf' | 'other' | null = null;
  filePreviewUrl: SafeResourceUrl | null = null;
  private rawPreviewUrl: string | null = null;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.signedUser = this.authService.getUserData();
  }

  async initialize(prevFiles: any[]) {
    this.uploadedPrevFiles = prevFiles;
    this.openDialog();
  }

  openDialog() {
    this.displayUploadDialog = true;
  }

  cancelDialog() {
    this.displayUploadDialog = false;
    this.resetFormFields();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    // Size limit (5MB)
    if (file.size > 5 * 1024 * 1024) {
      this.fileError = 'File size should be less than 5 MB';
      this.resetPreview();
      return;
    }

    this.fileError = null;
    this.resetPreview();

    this.rawPreviewUrl = URL.createObjectURL(file);

    if (file.type.startsWith('image/')) {
      this.filePreviewType = 'image';
      this.filePreviewUrl =
        this.sanitizer.bypassSecurityTrustUrl(this.rawPreviewUrl);
    } else if (file.type === 'application/pdf') {
      this.filePreviewType = 'pdf';
      this.filePreviewUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(this.rawPreviewUrl);
    } else {
      this.filePreviewType = 'other';
      this.filePreviewUrl = null;
    }

    this.uploadedFile = {
      createdAt: new Date().toLocaleDateString(),
      file,
      fileExt: file.type,
      fileName: file.name,
      fileDescription: this.fileDescription,
    };
  }

  save() {
    if (!this.uploadedFile) {
      this.messageService.errorToast(
        this.translate.instant('common.error'),
        this.translate.instant('Lütfen eksik alanları doldurunuz')
      );
      return;
    }

    this.fileAdded.emit({
      file: this.uploadedFile?.file,
      fileName: this.uploadedFile?.fileName,
      fileExt: this.uploadedFile?.fileExt,
      filePath: this.moduleName,
      createdBy: this.signedUser?.id,
      fileDescription: this.fileDescription,
    });

    this.displayUploadDialog = false;
    this.resetFormFields();
  }

  private resetPreview() {
    if (this.rawPreviewUrl) {
      URL.revokeObjectURL(this.rawPreviewUrl);
    }
    this.rawPreviewUrl = null;
    this.filePreviewUrl = null;
    this.filePreviewType = null;
  }

  resetFormFields() {
    this.fileDescription = '';
    this.uploadedFile = null;
    this.fileError = null;
    this.resetPreview();

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }

    this.cdr.detectChanges();
  }
}
